import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import MESSAGES from '../../../../../appMessages';
import { getLastWaveRoute } from './utils';
import { withStyles } from '@material-ui/core';

const styles = () => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
    fontWeight: 400
  },
  routeName: {
    fontWeight: 600
  }
});

const LastWaveSection = ({ data, classes }) => {
  const lastWaveRoute = getLastWaveRoute(data);
  if (!lastWaveRoute) return null;
  return (
    <div className={classes.container}>
      <span>
        <InfoOutlinedIcon />
      </span>
      <span>{MESSAGES.ROUTE_OPTIMIZATION.LAST_WAVE_MESSAGE}</span>
      <span className={classes.routeName}>{lastWaveRoute}</span>
    </div>
  );
};

export default withStyles(styles)(LastWaveSection);
